module.exports = __webpack_public_path__ + "img/img_card.8c1a57dd.png";